import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule, FormGroup, ReactiveFormsModule, Validators, FormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import { CoreModule } from 'app/core/core.module';
import { saveP2PEventCount } from 'app/manage-p2p/features/p2p.actions';
import { ModalAddP2pMilestoneService } from 'app/manage-p2p/services/modal-p2p-add-milestone/modal-add-p2p-milestone.service';
import { PeerToPeerManageService } from 'app/manage-p2p/services/peer-to-peer-manage/peer-to-peer-manage.service';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';

@Component({
  selector: 'app-p2p-add-milestone-modal',
  standalone: true,
  imports: [
    CommonModule, 
    FormsModule, 
    ReactiveFormsModule, 
    CoreModule, 
    MdbFormsModule
  ],
  templateUrl: './p2p-add-milestone-modal.component.html',
  styleUrl: './p2p-add-milestone-modal.component.scss'
})
export class P2pAddMilestoneModalComponent implements OnInit {
  @Input() data;

  public eventCountErrorText: string = 'Invalid Count';

  public form = new FormGroup({
    eventCount: new FormControl('', [Validators.required, Validators.min(0)])
  });

  constructor(
    public peerToPeerManageService: PeerToPeerManageService,
    public modalAddP2pMilestoneService: ModalAddP2pMilestoneService,
    private store: Store,
  ) {}
  
  ngOnInit(): void {
    const maxEventCount = this.data?.campaignData?.campaignTypeData?.maxEventCount;
    this.form.get('eventCount').addValidators(Validators.max(maxEventCount));

    if (this.data?.eventCount > 0) {
      this.form.get('eventCount').setValue(this.data.eventCount);
    }
  }

  addMilestone() {
    this.form.markAllAsTouched();

    if (!this.form.valid) {
      this.eventCountErrorText = `Please provide Milestones from 1 to ${this.data.campaignData.campaignTypeData.maxEventCount}`
      return;
    }

    const params = {
      campaignId: this.data.campaignData.id,
      p2pId: this.data.id,
      eventCount: parseInt(this.form.get('eventCount').value)
    }

    this.store.dispatch({
      type: saveP2PEventCount.type,
      payload: params
    });

    this.close();
  }

  close() {
    this.modalAddP2pMilestoneService.close();
  }
}
